'use strict';
import { newModalFromString } from 'components/modal';
function createCookie (name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toGMTString();
    } else {
        expires = '';
    }
    document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=/';
}

function readCookie (name) {
    var nameEQ = encodeURIComponent(name) + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
    }
    return null;
}
class PrivacyPolicyPopUP {
    init () {
        this.policyPrivacyFlag();
    }

    policyPrivacyFlag () {
      
        if ($('.privacyFlag-popup__content-cell').length > 0) {
            var day = 1;
            var firstEnter = true;
            if ('privacyPopUPCount' in localStorage) {
                var date1 = new Date();
                var date2 = new Date(localStorage.getItem('privacyPopUPCount')).getTime() - date1.getTime();
                day = date2 / (24 * 60 * 60 * 1000);
                firstEnter = false;
            }
            if (day > 0) {
                var cookie = readCookie('privacyPopUP');
                var optanonConsent = readCookie('OptanonConsent');
                var cookieOpta = false;
                if (optanonConsent) {
                    var group = null;
                    var optanonConsentSplit = optanonConsent.split('&');
                    if (optanonConsentSplit.length > 0) {
                        var nameEQ = 'groups';
                        for (var i = 0; i < optanonConsentSplit.length; i++) {
                            var c = optanonConsentSplit[i];
                            if (c.indexOf(nameEQ) === 0) {
                                group = decodeURIComponent(c.substring(nameEQ.length, c.length));
                            }
                        }
                        if (group) {
                            group = group.replace('=', '');
                            var groupSplit = group.split(',');
                            if (groupSplit.length > 0) {
                                for (var j = 0; j < groupSplit.length; j++) {
                                    var cg = groupSplit[j];
                                    if (cg.indexOf('C0009:1') === 0) {
                                        cookieOpta = true;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!cookie && cookieOpta) {
                    var openPopUP = true;
                    if (day <= 60 && !firstEnter) {
                        var dataUser = $('.privacyFlag-popup__content-cell').data('page-arrive');
                        var dataUserPersistent = $('.privacyFlag-popup__content-cell').data('user-persistent');
                        if (dataUserPersistent) {
                            if (dataUser !== 'PERSISTENT') {
                                openPopUP = false;
                            }
                        }
                    }
                    if (openPopUP) {
                        createCookie('privacyPopUP', true, 30);
                        if (localStorage.getItem('privacyPopUPCount') === null) {
                            var date = new Date();
                            date.setTime(date.getTime() + (90 * 24 * 60 * 60 * 1000));
                            localStorage.setItem('privacyPopUPCount', date);
                        }
                        const htmlContent = $('.privacyFlagEnable').html();
                        const modal = newModalFromString(htmlContent, false);
                        modal.open();
                        $('.tingle-modal').addClass('privacyFlagEnable');
                        var form = modal.modalBox.querySelector('div.editPrivacyPolicyForm');
                        form.addEventListener('change', function () {
                            $('.activable-after-change').prop('disabled', false);
                        });

                        $(modal.modalBox).on('change', '.add-to-email-popup', function (e) {
                            if (e.target.id === 'add-to-email-list-yes-popup' && e.target.checked) {
                                $('.add-to-personalized-list-popup').prop('disabled', false);
                                $('.profiling-preferences, .profiling-preferences-switches').removeClass('transparent');
                                $('.profiling-preferences-text').removeClass('disabled');
                            } else {
                                $('.add-to-personalized-list-popup').prop('checked', false);
                                $('.add-to-personalized-list-popup').prop('disabled', true);
                                $('.add-to-personalized-list-popup').removeAttr('required');
                                $('.profiling-preferences, .profiling-preferences-switches').addClass('transparent');
                                $('.profiling-preferences-text').addClass('disabled');
                            }
                        });
                        $(modal.modalBox).on('click', '.modify-consent', function (e) {
                            $('.privacy_step1').removeClass('hide');
                            $('.buttons-modifyConsent').addClass('hide');
                            $('body').trigger('analytics:privacyPopUP', { action: 'change_your_consents', privacyNews: '', privacyCustomNews: '' });
                        });

                        $(modal.modalBox).on('click', '.closePrivacyPopUP', function (e) {
                            $('body').trigger('analytics:privacyPopUP', { action: 'close', privacyNews: '', privacyCustomNews: '' });
                            modal.close();
                            modal.destroy();
                        });
                        $(modal.modalBox).on('click', '.continue-consent', function (e) {
                            $('body').trigger('analytics:privacyPopUP', { action: 'go_ahead_shopping', privacyNews: '', privacyCustomNews: '' });
                            modal.close();
                            modal.destroy();

                        });


                        $(modal.modalBox).on('click', '.privacy-policy-short-marketing', function (e) {
                            e.preventDefault();
                            const htmlContent = $('.js-modal-privacy-policy-marketing').html();
                            var tabContent = $('.js-content-privacy-policy-marketing').html();

                            const onPopupClose = () => {
                                //unlockScroll();
                            };

                            // create and open confirmation modal
                            const modalP = newModalFromString(htmlContent, false, ['privacy-policy-marketing-popup'], null, onPopupClose);
                            modalP.open();
                            modalP.setContent(tabContent);
                            $(modalP.modalBox)
                                .find('.close-button-privacy')
                                .on('click', function (e) {
                                    modalP.close();
                                });
                        });

                        $(modal.modalBox).on('click', '.privacy-policy-short-profiling', function (e) {
                            e.preventDefault();
                            const htmlContent = $('.js-modal-privacy-policy-profiling').html();
                            var tabContent = $('.js-content-privacy-policy-profiling').html();

                            const onPopupClose = () => {
                                //unlockScroll();
                            };

                            // create and open confirmation modal
                            const modalP = newModalFromString(htmlContent, false, ['privacy-policy-profiling-popup'], null, onPopupClose);

                            modalP.open();
                            modalP.setContent(tabContent);
                            $(modalP.modalBox)
                                .find('.close-button-privacy')
                                .on('click', function (e) {
                                    modalP.close();
                                });
                        });
                        $(modal.modalBox).on('click', '.submit-edit-flag', function (e) {
                            var profilengAgreement = $('input[name=profilingAgreement]:checked').val();
                            var directMarketingAgreementFlag = $('input[name=directMarketingAgreement]').prop('checked');
                            var url = $('.editPrivacyPolicy').val();
                            $.ajax({
                                url: url,
                                method: 'POST',
                                data: {
                                    directMarketingAgreement: directMarketingAgreementFlag ? directMarketingAgreementFlag : 'false',
                                    profilingAgreement: profilengAgreement ? profilengAgreement : 'false'
                                },
                                success: data => {
                                    if (data.success) {
                                        $('.editPrivacyPolicyForm').addClass('hide');
                                        $('.privacy-response-ok').removeClass('hide');
                                        $('.privacypopUPTitle').addClass('hide');
                                        $('.privacypopUPTitleModify').addClass('hide');
                                        $('body').trigger('analytics:privacyPopUP', { action: 'save_your_preferences', privacyNews: directMarketingAgreementFlag ? 'on-news_and_promotions' : 'off-news_and_promotions', privacyCustomNews: profilengAgreement ? 'on-custom_news_and_promotions' : 'off-custom_news_and_promotions' });
                                    } else {
                                        $('.js-links-order-document-error').removeClass('hide');
                                    }
                                },
                                error: data => {
                                    $('.js-links-order-document-error').removeClass('hide');
                                    $.spinner().stop();
                                }
                            }).then(function () {
                                $.spinner().stop();
                            });
                        });
                    }
                }
            }
        }
    }
}

let privacyPopUP = new PrivacyPolicyPopUP();
export default privacyPopUP;
